module.exports = __webpack_public_path__ + "static/media/icon-cross.3b9d3099.png";